var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from './Tooltip';
import { danger, slate } from './colors';
import SimpleDate from './SimpleDate';
import InlineButton from './Utilities/InlineButton';
import BlockButton from './Utilities/BlockButton';
const badgeStyle = {
    position: 'absolute',
    fontSize: '10px',
    top: '-4px',
    left: '12px',
    borderRadius: '50%',
    padding: '1px 4px',
    backgroundColor: danger.base,
    color: 'white',
};
export default class Notifications extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            show: false,
            windowHeight: 0,
        };
        this.updateWindowDimensions = () => {
            this.setState({ windowHeight: window.innerHeight });
        };
        this.handleClose = () => {
            this.props.onClose && this.props.onClose();
            this.setState({ show: false });
        };
        this.handleOpen = () => {
            this.props.onOpen && this.props.onOpen();
            if (this.props.showNotificationsOnClick) {
                this.setState({ show: true });
            }
        };
    }
    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }
    render() {
        const _a = this.props, { onOpen, notifications, errorMessage, numberUnread, snippetLength, readMoreComponent, noNotificationsText, dateTimeComponent, viewAllComponent, constraints, showNotificationsOnClick } = _a, rest = __rest(_a, ["onOpen", "notifications", "errorMessage", "numberUnread", "snippetLength", "readMoreComponent", "noNotificationsText", "dateTimeComponent", "viewAllComponent", "constraints", "showNotificationsOnClick"]);
        const formattedNotifications = (React.createElement("div", null, notifications.map((notification, idx) => {
            const tooLong = snippetLength ? notification.message.length > snippetLength : false;
            const message = tooLong
                ? notification.message
                    .split(' ')
                    .slice(0, snippetLength / 5)
                    .join(' ') + '... '
                : notification.message;
            const link = tooLong && readMoreComponent ? readMoreComponent({ date: notification.timestamp }) : null;
            return (React.createElement("div", { key: idx },
                React.createElement("div", { className: "h6", style: { color: slate } }, dateTimeComponent({ date: notification.timestamp })),
                React.createElement("div", null,
                    message,
                    link && React.createElement(InlineButton, { onClick: this.handleClose }, link))));
        })));
        const error = (React.createElement("b", { className: "text-danger" },
            React.createElement("i", { className: "fa fa-exclamation-triangle" }),
            " ",
            errorMessage));
        const popoverContents = (React.createElement("div", { style: { maxHeight: this.state.windowHeight } },
            React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', width: '246px' } },
                React.createElement("h5", null, "Notifications"),
                viewAllComponent && React.createElement(BlockButton, { style: { width: 'auto' }, onClick: this.handleClose }, viewAllComponent)),
            React.createElement("div", { style: { maxHeight: this.state.windowHeight - 30, overflowY: 'auto' } }, notifications.length ? formattedNotifications : errorMessage ? error : noNotificationsText)));
        return (React.createElement(Tooltip, Object.assign({ direction: "bottom", contents: popoverContents, show: this.state.show, onClickOutside: () => this.state.show && this.handleClose(), variant: "popover", constraints: constraints, style: { margin: '0 8px 0 0' } }, rest),
            React.createElement(InlineButton, { onClick: () => (this.state.show ? this.handleClose() : this.handleOpen()), className: "clickable", style: { position: 'relative', height: '22px', width: '25px', textAlign: 'center' } },
                React.createElement("i", { className: "fa fa-bell-o fa-lg", style: { padding: '4px 0' } }),
                numberUnread > 0 && React.createElement("span", { style: badgeStyle }, numberUnread))));
    }
}
Notifications.propTypes = {
    notifications: PropTypes.arrayOf(PropTypes.shape({
        message: PropTypes.string.isRequired,
        timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })),
    errorMessage: PropTypes.string,
    numberUnread: PropTypes.number,
    snippetLength: PropTypes.number,
    readMoreComponent: PropTypes.func,
    viewAllComponent: PropTypes.node,
    dateTimeComponent: PropTypes.func,
    noNotificationsText: PropTypes.string,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    constraints: PropTypes.arrayOf(PropTypes.object),
    showNotificationsOnClick: PropTypes.bool,
};
Notifications.defaultProps = {
    notifications: [],
    noNotificationsText: 'No unread notifications',
    snippetLength: 0,
    numberUnread: 0,
    dateTimeComponent: ({ date }) => React.createElement(SimpleDate, { date: date }),
    constraints: [
        {
            to: 'scrollParent',
            attachment: 'bottom',
            pin: ['left', 'right'],
        },
    ],
    showNotificationsOnClick: true,
};
